import React from "react";

interface UnauthorizedOverlayProps {
  message: string;
}

const UnauthorizedOverlay: React.FC<UnauthorizedOverlayProps> = ({ message }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded shadow-md max-w-md w-full text-center">
        <p className="mb-4">{message}</p>
        <a href="/logout" className="block text-blue-500 hover:underline mb-2">
          Logout and re-authenticate
        </a>
        <a href="/request-access" className="block text-blue-500 hover:underline">
          Request Admin Access
        </a>
      </div>
    </div>
  );
};

export default UnauthorizedOverlay;
